import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

Vue.config.productionTip = false

Vue.prototype.$showModal = false;

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
